import { isModernBridge } from '@/common/bridge/mode';

import * as CommsService from '../comms.service';
import { CommsCommand } from '../comms.enum';
import type { OpenRequestCreatedPayload } from '../comms.types';

/** The created-ticket fields needed to build the host-facing payload. */
type CreatedTicket = Pick<OpenRequestCreatedPayload, 'id' | 'subject' | 'isCreated' | 'recipientAddress'>;

/**
 * Emit the `open_request_created` event to the host page after a successful open
 * request creation. Shared across all open-request flows (logged-in modal, guest
 * OTP, controller createTicket) so the emit lives in one place. No-op outside
 * modern SDK bridge mode.
 */
export function emitOpenRequestCreated(
  ticket: CreatedTicket,
  extra?: { description?: string; chatbotSessionId?: string }
): void {
  if (!isModernBridge()) {
    return;
  }

  const payload: OpenRequestCreatedPayload = {
    id: ticket.id,
    subject: ticket.subject,
    isCreated: ticket.isCreated,
    description: extra?.description,
    recipientAddress: ticket.recipientAddress,
    chatbotSessionId: extra?.chatbotSessionId,
  };

  CommsService.post(CommsCommand.emit.openRequestCreated, payload);
}
